function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.1669 1H5.11613C2.90299 1 1.10889 2.79411 1.10889 5.00725V33.058C1.10889 35.2711 2.90299 37.0652 5.11613 37.0652H33.1669C35.38 37.0652 37.1741 35.2711 37.1741 33.058V5.00725C37.1741 2.79411 35.38 1 33.1669 1Z",
  stroke: "#0065B1",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4131 12.1631H13.1305M13.1305 12.1631H26.8696M13.1305 12.1631V24.1848C13.1305 24.6403 13.3114 25.0771 13.6335 25.3992C13.9556 25.7212 14.3924 25.9022 14.8479 25.9022H23.4348C23.8903 25.9022 24.3271 25.7212 24.6492 25.3992C24.9713 25.0771 25.1522 24.6403 25.1522 24.1848V12.1631H13.1305ZM15.7066 12.1631V10.4457C15.7066 9.99018 15.8875 9.55336 16.2096 9.23128C16.5317 8.90921 16.9685 8.72827 17.424 8.72827H20.8587C21.3142 8.72827 21.751 8.90921 22.0731 9.23128C22.3952 9.55336 22.5761 9.99018 22.5761 10.4457V12.1631M17.424 16.4565V21.6087M20.8587 16.4565V21.6087",
  stroke: "#0065B1",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgBasket = function SvgBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basket.861ef6b2.svg";
export { ForwardRef as ReactComponent };